(function () {

  'use strict';

  angular.module('PrintixInfoWorkstation', [])

    .constant('PrintixWorkstationInfoConstants', {
      SHOW: 'workstation_info_show',
      HIDE: 'workstation_info_hide'
    })

    .constant('PrintixWorkstationInfoSelectors', {
      MODAL_ID: 'infoWorkstationModal',
      CONFIRM_BUTTON_CSS_CLASS: 'confirm-button'
    })

    .controller('InfoWorkstationController', function ($rootScope, $scope, PrintixWorkstationInfoConstants, SUPPORTED_OS, PrintixWorkstationInfoSelectors) {

      $scope.workstation = null;
      $scope.workstationInfoModalId = PrintixWorkstationInfoSelectors.MODAL_ID;
      $scope.supportedOperatingSystems = SUPPORTED_OS;

      $scope.clearWorkstationInfo = function () {
        $scope.workstation = null;
      };

      let locationChangeListener = function () {};
      $scope.showWorkstationInfo = function (workstation) {
        if (workstation) {
          $scope.workstation = angular.copy(workstation);
          const workstationModal = angular.element('#' + $scope.workstationInfoModalId);
          workstationModal.modal('show');
          locationChangeListener = $rootScope.$on('$locationChangeStart', function () {
            workstationModal?.modal('hide');
          });
        } else {
          throw new Error('$scope.showWorkstationInfo: workstation is missing');
        }
      };

      const SHOW_listener = $rootScope.$on(PrintixWorkstationInfoConstants.SHOW, function (name, workstation) {
        $scope.showWorkstationInfo(workstation);
      });

      $scope.$on('$destroy', function () {
        SHOW_listener();
      });

    })

    .directive('infoWorkstationObjectControl', function ($rootScope, PrintixWorkstationInfoSelectors, PrintixWorkstationInfoConstants) {
      return {
        link: function ($scope, element, attrs) {

          element.on('hide.bs.modal', function () {
            $scope.clearWorkstationInfo(angular.element(document.activeElement).hasClass(PrintixWorkstationInfoSelectors.CONFIRM_BUTTON_CSS_CLASS));
          });

          const HIDE_listener = $rootScope.$on(PrintixWorkstationInfoConstants.HIDE, function () {
            element.modal('hide');
          });

          $scope.$on('$destroy', function () {
            HIDE_listener();
          });

        }
      };
    });

})();
